import { NextPage } from "next";
import { Layout } from "@kursk/components/Layout/Layout";
import React from "react";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { articlesSlice } from "@common/redux/slices/articles.slice";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { HeaderBlock } from "@kursk/components/ui/HeaderBlock/HeaderBlock";
import styles from "./SingleRoute.module.scss";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { ContentBlock } from "@kursk/components/ui/ContentBlock/ContentBlock";
import { Tags } from "@kursk/components/ui/Tags/Tags";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { regionContent } from "@kursk/content/regionContent";

export const SingleRoute: NextPage = () => {
  const { article } = useSelectSlice(articlesSlice);
  const { routes } = useSelectSlice(recommendationSlice);
  if (!article) {
    return <></>;
  }
  return (
    <Layout>
      <SeoMetaTitles page="singleRoute" entity={{ name: article.name, seo: article.seo, image: article.image }}
        showOgImage={true}/>
      <section className={styles.routes_header}>
        <HeaderBlock
          entityType={'routes'}
          entity={article}
          goBack={'/routes'}
          goBackTitle={`вернуться к списку ${regionContent.entitiesNames.routes.pluralGenitive}`}/>
      </section>
      <section className={styles.routes_socialLinks}>
        <SocialLinks/>
      </section>
      <section className={styles.routes_content}>
        <ContentBlock content={article?.content} source={article?.source}/>
      </section>
      <section className={styles.routes_tags}>
        <Tags link={'/events'} className={styles.routes_inner} tags={article?.tags}/>
      </section>
      <section className={styles.routes_recommendations}>
        <RecommendationsBlock
          entityType="routes"
          data={routes}
          title={'также рекомендуем'}
          goTo={'/routes'}
          goToTitle={`все ${regionContent.entitiesNames.routes.plural}`}/>
      </section>
      <section className={styles.routes_socials}>
        <Socials/>
      </section>
    </Layout>
  )
}
